const development_tenant = {
    notification: '你處於開發模式',
};
export default Object.freeze(development_tenant);
